import plugins from '../plugins'

export default function (param) {
    plugins.call('system',{
        action:"browser",
        param:param.url
    },param.success)
}